import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Add from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";

const styles = () => ({
    moveIt: {
        margin: "0 0 10px",
        padding: 0,
        "&:hover": {
            background: "transparent",
        },
    },

    root: {
        border: "2px dashed #2C99D2",
        color: "#2C99D2",
        margin: "10px 0 20px",
        padding: "11px 16px",
        width: "100%",
        justifyContent: "start",
        "&hover": {
            backgroundColor: "rgba(44, 153, 210, 0.08)",
        },
    },
});

const MoveItButton = styled(Button)({
    margin: "0 0 10px",
    padding: 0,
    "&:hover": {
        background: "transparent",
    },
});

const RootButton = styled(Button)({
    border: "2px dashed #2C99D2",
    color: "#2C99D2",
    margin: "10px 0 20px",
    padding: "11px 16px",
    width: "100%",
    justifyContent: "start",
    "&:hover": {
        backgroundColor: "rgba(44, 153, 210, 0.08)",
    },
});
const MultiAddInput = (props) => {
    const { disableInputs, elements, onAdd, addButtonText, buttonType, displayFirstWhenEmpty, render } = props;
    useEffect(() => {
        if (displayFirstWhenEmpty === true && !disableInputs) {
            if (elements) {
                if (Array.isArray(elements)) {
                    if (elements && elements.length === 0) {
                        onAdd();
                    }
                } else if (Object.keys(elements).length === 0) {
                    onAdd();
                }
            } else {
                console.log(elements);
                onAdd();
            }
        }
    }, [elements, displayFirstWhenEmpty, disableInputs, onAdd]);

    return (
        <div>
            {Array.isArray(elements)
                ? elements &&
                  elements.length > 0 &&
                  elements.map((e, i) => {
                      return <React.Fragment>{render(e, i)}</React.Fragment>;
                  })
                : elements &&
                  Object.keys(elements).length > 0 &&
                  Object.keys(elements).map((c, i) => {
                      const element = elements[c];
                      return <React.Fragment>{render(element, c)}</React.Fragment>;
                  })}
            {buttonType === "card" ? (
                <RootButton disabled={disableInputs} onClick={() => onAdd()}>
                    <Add />
                    {addButtonText}
                </RootButton>
            ) : (
                <MoveItButton disabled={disableInputs} color="primary" onClick={() => onAdd()}>
                    <Add fill="#4b94c1" /> {addButtonText}
                </MoveItButton>
            )}
        </div>
    );
};

export default MultiAddInput;
